export enum ELeasePacketUrls {
  ACCESS_CODE = 'access-code',
  PROPERTIES = 'properties',
}
